(function () {
  const DAY_STORAGE_KEY = 'rise-pearl-delivery-date-last-seen-jst';

  function getStorageItem(key) {
    try {
      return window.localStorage.getItem(key);
    } catch {
      return null;
    }
  }

  function setStorageItem(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch {
      return null;
    }
    return value;
  }

  function parseBoolean(value) {
    return value === true || value === 'true';
  }

  function parseJsonArray(value) {
    if (!value) return [];
    try {
      const parsed = JSON.parse(value);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }

  function getJstNow() {
    return new Date(new Date().toLocaleString('ja-JP', { timeZone: 'Asia/Tokyo' }));
  }

  function formatDate(date) {
    const year = date.getFullYear();
    const month = `${date.getMonth() + 1}`.padStart(2, '0');
    const day = `${date.getDate()}`.padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  function getTodayKey() {
    return formatDate(getJstNow());
  }

  function getCurrentCartState() {
    const stateSource = document.querySelector('[data-event-product-delivery]');
    if (!stateSource) return null;

    return {
      hasEventProduct: parseBoolean(stateSource.dataset.cartHasEventProduct),
      hasNonEventProducts: parseBoolean(stateSource.dataset.cartHasNonEventProducts),
      eventProductId: stateSource.dataset.cartEventProductId || '',
      eventProductTitle: stateSource.dataset.cartEventProductTitle || '',
    };
  }

  function syncDeliveryDateClear(input) {
    if (!window.fetchConfig || !window.routes?.cart_update_url) return Promise.resolve();

    const body = JSON.stringify({
      attributes: {
        'Delivery Date': '',
      },
    });

    return fetch(`${routes.cart_update_url}`, { ...fetchConfig(), body })
      .then(() => {
        if (input) input.value = '';
      })
      .catch((error) => {
        console.error(error);
      });
  }

  function updateCheckoutState(container, input) {
    const checkoutButtons = document.querySelectorAll('.cart__checkout-button');
    const additionalCheckoutContainers = document.querySelectorAll('.additional-checkout-buttons');
    const message = container.querySelector('[data-delivery-date-message]');
    const hasEventProduct = parseBoolean(container.dataset.cartHasEventProduct);
    const checkoutBlockedReason = container.dataset.cartCheckoutBlockReason;
    const allowedDates = parseJsonArray(container.dataset.cartEventDeliveryDatesJson);
    const currentValue = input?.value || '';
    const cartIsEmpty = document.querySelectorAll('.cart-item').length === 0;

    let blocked = parseBoolean(container.dataset.cartCheckoutBlocked);

    if (cartIsEmpty) {
      blocked = true;
    }

    if (checkoutBlockedReason === 'sales_period') {
      blocked = true;
    } else if (hasEventProduct) {
      if (!allowedDates.length) {
        blocked = true;
        container.dataset.cartCheckoutBlockReason = 'delivery_dates';
      } else if (!currentValue || !allowedDates.includes(currentValue)) {
        blocked = true;
        container.dataset.cartCheckoutBlockReason = 'delivery_date_required';
      } else {
        blocked = false;
        container.dataset.cartCheckoutBlockReason = '';
      }
    }

    container.dataset.cartCheckoutBlocked = blocked ? 'true' : 'false';

    checkoutButtons.forEach((button) => {
      if (blocked) {
        button.setAttribute('disabled', 'disabled');
      } else {
        button.removeAttribute('disabled');
      }
    });

    additionalCheckoutContainers.forEach((element) => {
      element.toggleAttribute('hidden', blocked);
    });

    if (!message) return;
    if (!hasEventProduct || container.dataset.cartCheckoutBlockReason === 'sales_period') {
      message.textContent = '';
      return;
    }
    if (container.dataset.cartCheckoutBlockReason === 'delivery_dates') {
      message.textContent = 'この商品は現在購入できません。';
      return;
    }
    if (blocked) {
      message.textContent = '配送希望日を選択してください。';
      return;
    }
    message.textContent = '';
  }

  function setupDeliveryContainer(container) {
    if (!container) return;

    const input = container.querySelector('[data-delivery-date-input]');
    if (!input) return;

    const todayKey = getTodayKey();
    const lastSeenDay = getStorageItem(DAY_STORAGE_KEY);
    const minDays = parseInt(container.dataset.deliveryMinDays || '4', 10);
    const maxDays = parseInt(container.dataset.deliveryMaxDays || '14', 10);
    const hasEventProduct = parseBoolean(container.dataset.cartHasEventProduct);
    const hasDeliveryDateDisabledProduct = parseBoolean(container.dataset.cartHasDeliveryDateDisabledProduct);
    const deliveryDateNeedsClear = parseBoolean(container.dataset.deliveryDateNeedsClear);
    const allowedDates = parseJsonArray(container.dataset.cartEventDeliveryDatesJson);

    if (!hasEventProduct && input.type === 'date') {
      const today = getJstNow();
      const minDate = new Date(today);
      minDate.setDate(today.getDate() + minDays);
      const maxDate = new Date(today);
      maxDate.setDate(today.getDate() + maxDays);
      input.min = formatDate(minDate);
      input.max = formatDate(maxDate);
    }

    let shouldClear = false;
    let shouldSyncClear = false;
    if (lastSeenDay && lastSeenDay !== todayKey) {
      shouldClear = true;
      shouldSyncClear = true;
    }
    if (hasDeliveryDateDisabledProduct && !hasEventProduct && deliveryDateNeedsClear) {
      shouldClear = true;
      shouldSyncClear = true;
    }
    if (hasEventProduct && input.value && !allowedDates.includes(input.value)) {
      shouldClear = true;
      shouldSyncClear = true;
    }

    if (shouldClear && input.value) {
      input.value = '';
    }

    if (shouldSyncClear) {
      syncDeliveryDateClear(input).then(() => {
        container.dataset.deliveryDateNeedsClear = 'false';
      });
    }

    setStorageItem(DAY_STORAGE_KEY, todayKey);

    if (!container.dataset.deliveryBound && input.type !== 'hidden') {
      input.addEventListener('change', () => {
        const currentHasEventProduct = parseBoolean(container.dataset.cartHasEventProduct);
        const currentAllowedDates = parseJsonArray(container.dataset.cartEventDeliveryDatesJson);
        if (currentHasEventProduct && input.value && !currentAllowedDates.includes(input.value)) {
          input.value = '';
        }
        updateCheckoutState(container, input);
      });
      container.dataset.deliveryBound = 'true';
    }

    updateCheckoutState(container, input);
  }

  function getMixedCartErrorMessage(formElement) {
    const targetIsEventProduct = parseBoolean(formElement.dataset.eventProductExclusive);
    const currentCartState = getCurrentCartState();
    const cartHasEventProduct = currentCartState
      ? currentCartState.hasEventProduct
      : parseBoolean(formElement.dataset.cartHasEventProduct);
    const cartHasNonEventProducts = currentCartState
      ? currentCartState.hasNonEventProducts
      : parseBoolean(formElement.dataset.cartHasNonEventProducts);
    const cartEventProductId = currentCartState ? currentCartState.eventProductId : formElement.dataset.cartEventProductId;
    const cartEventProductTitle = currentCartState
      ? currentCartState.eventProductTitle
      : formElement.dataset.cartEventProductTitle;
    const targetProductId = formElement.dataset.eventProductId;
    const targetProductTitle = formElement.dataset.eventProductTitle;

    if (cartHasEventProduct && !targetIsEventProduct) {
      return `「${cartEventProductTitle} と他の商品は一緒に購入ができません。」`;
    }

    if (!cartHasEventProduct && cartHasNonEventProducts && targetIsEventProduct) {
      return `「${targetProductTitle} と他の商品は一緒に購入ができません。」`;
    }

    if (cartHasEventProduct && targetIsEventProduct && cartEventProductId && cartEventProductId !== targetProductId) {
      return `「${targetProductTitle} と他の商品は一緒に購入ができません。」`;
    }

    if (cartHasEventProduct && cartHasNonEventProducts && targetIsEventProduct) {
      return `「${targetProductTitle} と他の商品は一緒に購入ができません。」`;
    }

    return '';
  }

  window.RisePearlEventProducts = {
    getMixedCartErrorMessage,
    setupDeliveryContainer,
    initialize() {
      const deliveryContainers = document.querySelectorAll('[data-event-product-delivery]');
      deliveryContainers.forEach((container) => {
        setupDeliveryContainer(container);
      });
    },
  };

  document.addEventListener('DOMContentLoaded', () => {
    window.RisePearlEventProducts.initialize();
  });

  document.addEventListener('shopify:section:load', () => {
    window.RisePearlEventProducts.initialize();
  });

  document.addEventListener('shopify:section:reorder', () => {
    window.RisePearlEventProducts.initialize();
  });

  if (window.subscribe && window.PUB_SUB_EVENTS?.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      window.setTimeout(() => {
        window.RisePearlEventProducts.initialize();
      }, 0);
    });
  }
})();
